export enum YesNoOptions {
  YES = 'true',
  NO = 'false',
}

export enum SimulationTypes {
  PRICE = 'PRICE',
  IRREGULAR = 'FLEXIBLE',
  SAA = 'SAA',
  SAC = 'SAC',
}

export enum InterestTypes {
  PRE = 'PRE',
  POS = 'POS',
}

export enum PreFixedTypes {
  BASE_30 = 'BASE_30',
  BASE_360 = 'BASE_360',
  BASE_365 = 'BASE_365',
}

export enum InterestRateFrequency {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  ANNUALLY = 'ANNUALLY',
}

export enum TacValueType {
  PERCENTAGE = 'PERCENTAGE',
  MONETARY = 'MONETARY',
}

export enum IofTypes {
  PERSON = 'PERSON',
  BUSINESS = 'BUSINESS',
  BUSINESS_SIMPLE = 'BUSINESS_SIMPLE',
  ZERO = 'ZERO',
}

export enum ScheduleTypes {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  BIWEEKLY = 'BIWEEKLY',
  MONTHLY = 'MONTHLY',
}

export enum PosFixedTypes {
  CDI = 'CDI',
  IPCA = 'IPCA',
  IGPM = 'IGP-M',
  SELIC = 'Selic',
  TR = 'TR',
}

export type TSimulationValidation = {
  numPeriods: string | null;
  interestRate: string | null;
  firstPaymentDate: string | null;
  paymentAmount: string | null;
  tacAmount: string | null;
  requested_amount: string | null;
};

export interface ISimulationResponse {
  base_rate: string;
  id: number;
  external_id: string;
  acronym: string;
  name: string;
  periodicity: string;
  type: string;
  validity_day: number;
  reference_rate: string;
  exchange_variation: string;
}

export interface IElegibilityConfigMinMax {
  min: number;
  max: number;
}

export interface IElegibilityConfigEducation {
  allowedDegrees: string[];
}

export interface IElegibilityConfigs {
  installments: IElegibilityConfigMinMax | null;
  age: IElegibilityConfigMinMax | null;
  operationValue: IElegibilityConfigMinMax | null;
  education: IElegibilityConfigEducation | null;
  interestRate: IElegibilityConfigMinMax | null;
}

export interface IElegibilityProduct {
  id: string;
}

export interface IElegibilityOriginator {
  id: string;
}

export interface IElegibilityIssuer {
  id: string;
}

export interface IElegibility {
  id: string;
  product: IElegibilityProduct;
  originator: IElegibilityOriginator;
  issuer: IElegibilityIssuer;
  active: boolean;
  configs: IElegibilityConfigs;
}
